<template><svg width="37" height="30" viewBox="0 0 37 30" fill="none" xmlns="http://www.w3.org/2000/svg">
<rect y="2" width="37" height="28" rx="5" fill="#6fd4bc"/>
<rect width="37" height="28" rx="5" fill="#6fd4bc"/>
<rect x="8" y="7" width="21" height="2" fill="#0B3459"/>
<rect x="8" y="13" width="21" height="2" fill="#0B3459"/>
<rect x="8" y="19" width="21" height="2" fill="#0B3459"/>
</svg></template><script>export default {}</script>
